export default "__VITE_ASSET__DMQ1Q3IJ__"